import { getLang } from "helpers/themeHelpers";

export const linkToLoanCalculator = () => {
  const locale = getLang();
  return `/${locale}/${locale === "ar" ? "حاسبة-القروض" : "loan-calculator"}`;
};
